import * as React from 'react';
import { Skeleton } from 'antd';
import { useConnectionState } from '../../visualDataMappingProvider';
import classes from './mapping-commons.module.scss';
import MappingInfo from './mappingView';
import SelectUniqueIdentifier from './SelectUniqueIdentifier';

const DataMapping: React.FC = () => {
  const { fields, columns, uniqueIdentifierConfig } = useConnectionState();
  const [loading, setLoading] = React.useState(
    !uniqueIdentifierConfig.original || !uniqueIdentifierConfig.mapped,
  );
  return !!columns && columns.length > 0 && !!fields && fields.length > 0 ? (
    <div className={classes.mapping_config_wrapper}>
      <SelectUniqueIdentifier setLoading={setLoading} />
      {!!uniqueIdentifierConfig?.mapped &&
        !!uniqueIdentifierConfig.original &&
        (!loading ? <MappingInfo /> : <Skeleton active paragraph={{ rows: 4 }} />)}
    </div>
  ) : null;
};

export default DataMapping;
